import {Box, IconButton, Typography} from "@mui/material";
import {FiSun, FiMoon} from "react-icons/fi";
import {useTheme} from "@mui/material/styles";
import {useThemeStore} from "../../stores/useThemeStore";

const ThemeToggleSimple = () => {
  const theme = useTheme();
  const {toggleTheme, isDark} = useThemeStore();

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      sx={{
        color: theme.palette.sidebar.itemText,
        cursor: "pointer"
      }}
      onClick={toggleTheme}
    >
      <IconButton
        sx={{
          padding: 0.5
        }}
      >
        {isDark() ? (
          <FiMoon size={16} color={theme.palette.sidebar.itemText} />
        ) : (
          <FiSun size={16} color={theme.palette.sidebar.itemText} />
        )}
      </IconButton>

      <Typography variant="subtitle1" fontWeight="bold">
        Theme
      </Typography>
    </Box>
  );
};

export default ThemeToggleSimple;
